module.exports = __webpack_public_path__ + "static/media/em-122.0f208b5b.png";